import { AuthenticatedLayout } from "@/app/AuthenticatedLayout";
import { BasicLayout } from "@/app/BasicLayout";
import { LoginPage } from "@/features/auth/pages/LoginPage";
import { DashboardPage } from "@/features/dashboard/pages/DashboardPage";
import { OrganizationsPage } from "@/features/organizations/pages/OrganizationsPage";
import { TempAccessPage } from "@/features/temp-access/pages/TempAccessPage";
import { UserDetailPage } from "@/features/users/pages/UserDetailPage";
import { UsersPage } from "@/features/users/pages/UsersPage";
import { RequireAuth } from "@/shared/auth/RequireAuth";
import { RootErrorBoundary } from "@/shared/components/RootErrorBoundary";
import { createBrowserRouter } from "react-router";

export const router = createBrowserRouter([
  {
    element: <BasicLayout />,
    errorElement: <RootErrorBoundary />,
    children: [{ path: "/login", element: <LoginPage /> }],
  },
  {
    element: <RequireAuth />,
    errorElement: <RootErrorBoundary />,
    children: [
      {
        element: <AuthenticatedLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "/users", element: <UsersPage /> },
          { path: "/users/:id", element: <UserDetailPage /> },
          { path: "/organizations", element: <OrganizationsPage /> },
          { path: "/temp-access", element: <TempAccessPage /> },
        ],
      },
    ],
  },
]);
